import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { ApiUrls } from '@app/AppConstants';
import { ChangeLogModel } from '@app/Models';

import DateTimeService from '@app/Services/DateTimeService';
import ApiService from '@app/Services/ApiService';

import { IModalDialogContent, ModalDialogOptions, ModalWindow, ModalButtonType } from '@app/Components/Modal';
import { PromiseCompletion } from '@app/Classes/PromiseCompletion';

type ChangeLogDialogProps = {
    personId: string;
};

@observer
export class ChangeLogDialog extends React.Component<ChangeLogDialogProps, {}> implements IModalDialogContent<void> {
    private _store: ChangeLogStore;

    constructor(props: ChangeLogDialogProps) {
        super(props);
        this._store = new ChangeLogStore(props.personId);
    }

    public getModalOptions(window: ModalWindow<void>): ModalDialogOptions<void> {
        return {
            width: '1500px',
            buttons: [{
                type: ModalButtonType.Cancel,
                onClick: () => {
                    window.close();
                }
            }],
            loader: this._store.loader
        };
    }

    render() {
        return (
            <>
                <table className={'fixed_headers'}>
                    <thead>
                        <tr>
                            <th>Modified</th>
                            <th>Modified by</th>
                            <th>Action</th>
                            <th>Object</th>
                            <th>Field</th>
                            <th>Old value</th>
                            <th>New value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!this._store.loader.isPending && this._store.data.length !== 0 && this._store.data.map((item) => {
                            return <React.Fragment key={item.id}>
                                <tr style={{ 'backgroundColor': '#f0f0f0' }}><td>{DateTimeService.toUiTimestamp(item.date)}</td>
                                    <td>{item.changedBy}</td><td /><td /><td /><td /><td /></tr>
                                {item.objects.length !== 0 && item.objects.map((object) => {
                                    return <React.Fragment key={`${object.id}-${object.objectType}`}>
                                        <tr><td /><td />
                                            <td>{object.actionType}</td><td>{object.objectType}</td><td /><td /><td /></tr>
                                        {object.fields.length !== 0 &&
                                            object.fields.map((field) => {
                                                return <tr key={field.id}>
                                                    <td /><td /><td />
                                                    <td /><td>{field.name}</td><td>{field.oldValue}</td><td>{field.newValue}</td>
                                                </tr>;
                                            })}
                                    </React.Fragment>;
                                })}
                            </React.Fragment>;
                        })}
                    </tbody>
                </table>
            </>
        );
    }
}

class ChangeLogStore {
    @observable data: ChangeLogModel[];
    public loader: PromiseCompletion = new PromiseCompletion();

    constructor(personId: string) {
        this.loadData(personId);
    }

    @action
    async loadData(personId: string) {
        const params = {
            personId: personId
        };
        const { data: days } = await ApiService.getTypedData<ChangeLogModel[]>(ApiUrls.ChangeLogUrl, params, { completion: this.loader });
        this.data = days;
    }
}